import { fetchCountry } from "../country/countryDetail";
import { fetchLocalities } from "../deliveryLocation/localityList";

export const doLogin = (history, email, password, title) => {
  return async (dispatch, getState) => {

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          password
        })
      }).then(r => r.json());

      if (response.error) { throw new Error(response.error) }

      window.localStorage.setItem('token', response.token);
      dispatch({ type: 'SESSION', response, requestStatus: 'FETCH' });

      dispatch(fetchCountry(response.countryId));

      if (response.roles.includes('administrator') || response.roles.includes('staff') || response.roles.includes('headsales'))
        dispatch(fetchLocalities('?all=true'))

      // TODO: Duplicated
      if (response.roles.includes('administrator')) {
        history.push('/admin/clients', { title: title });
        return;
      }

      if (response.roles.includes('client')) {
        history.push('/client/dashboard', { title: title });
        return;
      }

      if (response.roles.includes('vendor')) {
        history.push('/vendor/clients', { title: title });
        return;
      }

      if (response.roles.includes('staff')) {
        history.push('/staff/clients', { title: title });
        return;
      }

      if (response.roles.includes('headsales')) {
        history.push('/headsales/clients', { title: title });
        return;
      }

      if (response.roles.includes('manager')) {
        history.push('/manager/clients', { title: title });
        return;
      }

      if (response.roles.includes('person')) {
        history.push('/person/dashboard', { title: title });
        return;
      }


    } catch (error) {

      dispatch({
        type: 'SESSION',
        requestStatus: 'ERROR',
        newApiState: {
          isFetching: false,
          didInvalidate: true,
          error: error
        }
      })

    }

  }

}